import React from 'react';
import { BottomNavigation, BottomNavigationAction, Paper } from "@mui/material";

const getYear = () => {
  const date = new Date();
  return date.getFullYear();
};


const Footer = () => {
  const label = `© ${getYear()} Constellix Sonar. All rights reserved.`;
  return (
    <Paper sx={{ position: 'fixed', bottom: 0, left: 0, right: 0 }} elevation={3}>
    <BottomNavigation
      showLabels
     
    >
      <BottomNavigationAction label={label} />
    </BottomNavigation>
  </Paper>
  )
};

export default Footer;
